import { render, staticRenderFns } from "./QrModal.vue?vue&type=template&id=21b20e39&scoped=true&lang=pug&"
import script from "./QrModal.vue?vue&type=script&lang=js&"
export * from "./QrModal.vue?vue&type=script&lang=js&"
import style0 from "./QrModal.vue?vue&type=style&index=0&id=21b20e39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b20e39",
  null
  
)

export default component.exports